module.exports = __webpack_public_path__ + "static/media/Montserrat-Regular.57cf39e3.woff2";